import useInstallPrompt from '../hooks/useInstallPrompt'
import InstallBanner from './InstallBanner'
import IOSInstallModal from './IOSInstallModal'

/**
 * Single PWA install prompt controller.
 * Uses the hook once and passes props to the appropriate sub-component.
 */
export default function PWAInstallPrompt() {
    const prompt = useInstallPrompt()

    return (
        <>
            <InstallBanner {...prompt} />
            <IOSInstallModal {...prompt} />
        </>
    )
}
